import React, { useState } from 'react';
import axios from 'axios';
import '../styles/AddNewStudent.css';
import { useRef } from 'react'; // make sure to import useRef

const AddNewStudent = () => {
  // ⬆ Place this at the top where formData is initialized
const [formData, setFormData] = useState({
  fullName: '',
  dob: '',
  age: '',
  gender: '',
  address: '',
  category: '',
  className: '',
  fatherName: '',
  fatherProfession: '',
  motherName: '',
  motherProfession: '',
  guardianName: '',
  income: '',
  medicalConditions: '',
  aadharCardId: '',
  paymentMode: '',
  transactionId: '',
  phoneNumber: '',
  busRoute: '',
  casteCertificateNumber: '',         // NEW
  motherPhoneNumber: '',             // NEW
  previousSchoolAffiliation: '',     // NEW
  transferCertificateNumber: '',     // NEW
  previousSchoolName: '',            // NEW
  previousSchoolType: '',            // NEW
  previousSchoolPinCode: '',         // NEW
  previousSchoolAddress: ''          // NEW
});
const [submittedData, setSubmittedData] = useState(null);

  const formRef = useRef();
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'dob') {
      const birthDate = new Date(value);
      const today = new Date();
      const age = today.getFullYear() - birthDate.getFullYear();

      setFormData((prev) => ({
        ...prev,
        dob: value,
        age: age >= 0 ? age : ''
      }));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    const errors = [];
  
    if (!/^\d{12}$/.test(formData.aadharCardId)) {
      errors.push("Aadhar must be exactly 12 digits.");
    }
  
    if (!/^\d{10}$/.test(formData.phoneNumber)) {
      errors.push("Phone number must be exactly 10 digits.");
    }
  
    if (Number(formData.income) < 0 || isNaN(formData.income)) {
      errors.push("Income must be a non-negative number.");
    }
  
    if (Number(formData.age) < 0 || isNaN(formData.age)) {
      errors.push("Age must be a valid positive number.");
    }
    if (!/^\d{10}$/.test(formData.motherPhoneNumber)) {
      errors.push("Mother's phone number must be exactly 10 digits.");
    }
    if (formData.previousSchoolPinCode && !/^\d{6}$/.test(formData.previousSchoolPinCode)) {
      errors.push("Pin code must be 6 digits.");
    }
    
    // Optional: Check empty strings if necessary
    const requiredFields = ['fullName', 'dob', 'gender', 'address', 'category', 'className', 'fatherName', 'fatherProfession', 'motherName', 'motherProfession', 'income', 'aadharCardId', 'phoneNumber', 'paymentMode', 'transactionId'];
  
    requiredFields.forEach((field) => {
      if (!formData[field] || formData[field].trim() === '') {
        errors.push(`${field} is required and cannot be empty or just spaces.`);
      }
    });
  
    return errors;
  };
  
  const handlePrint = () => {
    const logoURL = "/school-logo.jpg";
  
    const htmlContent = `
      <html>
        <head>
          <title>Student Enrollment Form</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              margin: 20px;
              font-size: 14px;
              color: #000;
            }
            .header {
              text-align: center;
              margin-bottom: 20px;
            }
            .header img {
              height: 80px;
            }
            .header h2, .header h3 {
              margin: 5px 0;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
            }
            td, th {
              border: 1px solid #000;
              padding: 6px;
              vertical-align: top;
            }
            .section-title {
              background-color: #dbeaff;
              font-weight: bold;
              text-align: left;
              padding: 8px;
              font-size: 15px;
            }
            .signature-section {
              margin-top: 40px;
              display: flex;
              justify-content: space-between;
            }
            .signature-box {
              width: 45%;
              text-align: center;
            }
            .signature-box hr {
              margin: 40px 0 10px;
            }
          </style>
        </head>
        <body>
          <div class="header">
            <img src="${logoURL}" alt="School Logo" />
            <h2>Oxford Convent English Medium School, Khajuri</h2>
            <h3>Student Enrollment Form</h3>
          </div>
  
          ${generateEnrollmentTable(submittedData)}
  
          <div class="signature-section">
            <div class="signature-box">
              <hr />
              <p>Parent/Guardian Signature</p>
            </div>
            <div class="signature-box">
              <hr />
              <p>Principal Signature</p>
            </div>
          </div>
        </body>
      </html>
    `;
  
    const win = window.open('', '', 'height=800,width=1200');
    win.document.write(htmlContent);
    win.document.close();
  
    win.onload = () => {
      const images = win.document.images;
      let loaded = 0;
  
      if (images.length === 0) {
        win.print();
        return;
      }
  
      for (let img of images) {
        img.onload = img.onerror = () => {
          loaded++;
          if (loaded === images.length) {
            win.print();
          }
        };
      }
    };
  };
  
  // Helper to generate table content
  const generateEnrollmentTable = (data) => {
    return `
      <table>
        <tr><th colspan="4" class="section-title">Student Details</th></tr>
        <tr>
          <td><b>Full Name</b></td><td>${data?.fullName}</td>
          <td><b>DOB</b></td><td>${data?.dob}</td>
        </tr>
        <tr>
          <td><b>Age</b></td><td>${data?.age}</td>
          <td><b>Gender</b></td><td>${data?.gender}</td>
        </tr>
        <tr>
          <td><b>Address</b></td><td colspan="3">${data?.address}</td>
        </tr>
        <tr>
          <td><b>Category</b></td><td>${data?.category}</td>
          <td><b>Class</b></td><td>${data?.className}</td>
        </tr>
        <tr>
          <td><b>Caste Certificate No.</b></td><td>${data?.casteCertificateNumber}</td>
          <td><b>Mother's Phone</b></td><td>${data?.motherPhoneNumber}</td>
        </tr>
  
        <tr><th colspan="4" class="section-title">Family Details</th></tr>
        <tr>
          <td><b>Father's Name</b></td><td>${data?.fatherName}</td>
          <td><b>Profession</b></td><td>${data?.fatherProfession}</td>
        </tr>
        <tr>
          <td><b>Mother's Name</b></td><td>${data?.motherName}</td>
          <td><b>Profession</b></td><td>${data?.motherProfession}</td>
        </tr>
        <tr>
          <td><b>Guardian Name</b></td><td>${data?.guardianName}</td>
          <td><b>Annual Income</b></td><td>₹${data?.income}</td>
        </tr>
  
        <tr><th colspan="4" class="section-title">Medical & ID Details</th></tr>
        <tr>
          <td><b>Medical Conditions</b></td><td>${data?.medicalConditions}</td>
          <td><b>Aadhar Card ID</b></td><td>${data?.aadharCardId}</td>
        </tr>
  
        <tr><th colspan="4" class="section-title">Previous School Details</th></tr>
        <tr>
          <td><b>Affiliation</b></td><td>${data?.previousSchoolAffiliation}</td>
          <td><b>TC No.</b></td><td>${data?.transferCertificateNumber}</td>
        </tr>
        <tr>
          <td><b>School Name</b></td><td>${data?.previousSchoolName}</td>
          <td><b>Type</b></td><td>${data?.previousSchoolType}</td>
        </tr>
        <tr>
          <td><b>Pin Code</b></td><td>${data?.previousSchoolPinCode}</td>
          <td><b>Address</b></td><td>${data?.previousSchoolAddress}</td>
        </tr>
  
        <tr><th colspan="4" class="section-title">Contact Details</th></tr>
        <tr>
          <td><b>Phone Number</b></td><td>${data?.phoneNumber}</td>
          <td><b>Bus Route</b></td><td>${data?.busRoute}</td>
        </tr>
  
        <tr><th colspan="4" class="section-title">Payment Details</th></tr>
        <tr>
          <td><b>Payment Mode</b></td><td>${data?.paymentMode}</td>
          <td><b>Transaction ID</b></td><td>${data?.transactionId}</td>
        </tr>
      </table>
    `;
  };
  
  
  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (errors.length > 0) {
      alert(errors.join('\n'));
      return;
    }

    try {
      const response = await axios.post(
        'addStudent.php',
        formData,
        { withCredentials: true }  // ✅ Include session cookie
      );
      
      if (response.data.status === 'success') {
        alert('Student added successfully!');
        setSubmittedData({ ...formData });  // store the data for printing
      }
       else {
        alert('Error: ' + response.data.message);
      }
    } catch (error) {
      console.error('There was an error!', error);
      alert('There was an error submitting the form.');
    }
  };

  return (
    <div className="ans-container">
      <h2 className="ans-heading">Add New Student</h2>
      <form onSubmit={handleSubmit} className="ans-form">
        {/* All other inputs below remain unchanged, only a few will have maxLength/pattern */}
        
        <div className="ans-form-group">
  <label htmlFor="fullName">Full Name</label>
  <input
    type="text"
    name="fullName"
    id="fullName"
    value={formData.fullName}
    onChange={handleChange}
    required
    pattern=".*\S.*"
    title="Full Name cannot be empty or just spaces"
  />
</div>

        <div className="ans-form-group">
          <label htmlFor="dob">Date of Birth</label>
          <input type="date" name="dob" id="dob" value={formData.dob} onChange={handleChange} required />
        </div>

        <div className="ans-form-group">
          <label htmlFor="age">Age</label>
          <input type="number" name="age" id="age" value={formData.age} readOnly min="0" />
        </div>

        <div className="ans-form-group">
          <label htmlFor="gender">Gender</label>
          <select name="gender" id="gender" value={formData.gender} onChange={handleChange} required>
            <option value="">Select Gender</option>
            <option value="Male">Male</option>
            <option value="Female">Female</option>
            <option value="Other">Other</option>
          </select>
        </div>
        <div className="ans-form-group">
  <label htmlFor="phoneNumber">Phone Number</label>
  <input
    type="text"
    name="phoneNumber"
    id="phoneNumber"
    value={formData.phoneNumber}
    onChange={handleChange}
    minLength="10"
    maxLength="10"
    pattern="\d{10}"
    required
    title="Phone number must be exactly 10 digits"
  />
</div>


<div className="ans-form-group">
  <label htmlFor="address">Address</label>
  <textarea
    name="address"
    id="address"
    value={formData.address}
    onChange={handleChange}
    required
    pattern=".*\S.*"
    title="Address cannot be empty or just spaces"
  />
</div>


        <div className="ans-form-group">
          <label htmlFor="busRoute">Bus Route</label>
          <select name="busRoute" id="busRoute" value={formData.busRoute} onChange={handleChange} required>
            <option value="">Select Bus Route</option>
            <option value="Khajuri Local: ₹3500">Khajuri Local: ₹3500</option>
            <option value="Rudrawadi: ₹5000">Rudrawadi: ₹5000</option>
            <option value="Bableshwar: ₹4000">Bableshwar: ₹4000</option>
            <option value="Jawalaga (J): ₹4500">Jawalaga (J): ₹4500</option>
            <option value="Alanga: ₹6000">Alanga: ₹6000</option>
            <option value="Khandal: ₹6000">Khandal: ₹6000</option>
            <option value="No: ₹0">No: ₹0</option>
          </select>
        </div>

        <div className="ans-form-group">
          <label htmlFor="category">Category</label>
          <select name="category" id="category" value={formData.category} onChange={handleChange} required>
            <option value="">Select Category</option>
            <option value="General">General</option>
            <option value="OBC">OBC</option>
            <option value="SC">SC</option>
            <option value="ST">ST</option>
            <option value="Others">Others</option>
          </select>
        </div>

        <div className="ans-form-group">
          <label htmlFor="className">Class</label>
          <select name="className" id="className" value={formData.className} onChange={handleChange} required>
            <option value="">Select Class</option>
            <option value="Nursery">Nursery</option>
            <option value="LKG">LKG</option>
            <option value="UKG">UKG</option>
            <option value="1">1</option>
            <option value="2">2</option>
            <option value="3">3</option>
            <option value="4">4</option>
            <option value="5">5</option>
            <option value="6">6</option>
            <option value="7">7</option>
            <option value="8">8</option>
            <option value="9">9</option>
            <option value="10">10</option>
          </select>
        </div>
        <div className="ans-form-group">
  <label htmlFor="fatherName">Father's Name</label>
  <input
    type="text"
    name="fatherName"
    id="fatherName"
    value={formData.fatherName}
    onChange={handleChange}
    required
    pattern=".*\S.*"
    title="Father's Name cannot be empty or only spaces"
  />
</div>

<div className="ans-form-group">
  <label htmlFor="fatherProfession">Father's Profession</label>
  <input
    type="text"
    name="fatherProfession"
    id="fatherProfession"
    value={formData.fatherProfession}
    onChange={handleChange}
    required
    pattern=".*\S.*"
    title="Father's Profession cannot be empty or only spaces"
  />
</div>

<div className="ans-form-group">
  <label htmlFor="motherName">Mother's Name</label>
  <input
    type="text"
    name="motherName"
    id="motherName"
    value={formData.motherName}
    onChange={handleChange}
    required
    pattern=".*\S.*"
    title="Mother's Name cannot be empty or only spaces"
  />
</div>

<div className="ans-form-group">
  <label htmlFor="motherProfession">Mother's Profession</label>
  <input
    type="text"
    name="motherProfession"
    id="motherProfession"
    value={formData.motherProfession}
    onChange={handleChange}
    required
    pattern=".*\S.*"
    title="Mother's Profession cannot be empty or only spaces"
  />
</div>

<div className="ans-form-group">
  <label htmlFor="guardianName">Guardian's Name</label>
  <input
    type="text"
    name="guardianName"
    id="guardianName"
    value={formData.guardianName}
    onChange={handleChange}
    pattern=".*\S.*"
    title="Guardian's Name cannot be just spaces"
  />
</div>

<div className="ans-form-group">
  <label htmlFor="income">Income</label>
  <input
    type="number"
    name="income"
    id="income"
    value={formData.income}
    onChange={handleChange}
    required
    min="0"
    title="Income must be a non-negative number"
  />
</div>

<div className="ans-form-group">
  <label htmlFor="medicalConditions">Medical Conditions</label>
  <textarea
    name="medicalConditions"
    id="medicalConditions"
    value={formData.medicalConditions}
    onChange={handleChange}
    pattern=".*\S.*"
    title="If filled, this field cannot be just spaces"
  />
</div>


        <div className="ans-form-group">
          <label htmlFor="aadharCardId">Aadhar Card ID</label>
          <input type="text" name="aadharCardId" id="aadharCardId" value={formData.aadharCardId} onChange={handleChange}  minLength="12"
    maxLength="12"
    pattern="\d{12}"
    required
    title="Aadhar number must be exactly 12 digits" />
        </div>
        <div className="ans-form-group">
  <label htmlFor="casteCertificateNumber">Caste Certificate Number</label>
  <input
    type="text"
    name="casteCertificateNumber"
    id="casteCertificateNumber"
    value={formData.casteCertificateNumber}
    onChange={handleChange}
  />
</div>

<div className="ans-form-group">
  <label htmlFor="motherPhoneNumber">Mother's Phone Number</label>
  <input
    type="text"
    name="motherPhoneNumber"
    id="motherPhoneNumber"
    value={formData.motherPhoneNumber}
    onChange={handleChange}
    pattern="\d{10}"
    maxLength="10"
    minLength="10"
    title="Must be 10 digits"
  />
</div>

<hr />
<h3>Previous School Details</h3>

<div className="ans-form-group">
  <label htmlFor="previousSchoolAffiliation">Previous School Affiliation</label>
  <input
    type="text"
    name="previousSchoolAffiliation"
    id="previousSchoolAffiliation"
    value={formData.previousSchoolAffiliation}
    onChange={handleChange}
  />
</div>

<div className="ans-form-group">
  <label htmlFor="transferCertificateNumber">Transfer Certificate Number</label>
  <input
    type="text"
    name="transferCertificateNumber"
    id="transferCertificateNumber"
    value={formData.transferCertificateNumber}
    onChange={handleChange}
  />
</div>

<div className="ans-form-group">
  <label htmlFor="previousSchoolName">Previous School Name</label>
  <input
    type="text"
    name="previousSchoolName"
    id="previousSchoolName"
    value={formData.previousSchoolName}
    onChange={handleChange}
  />
</div>

<div className="ans-form-group">
  <label htmlFor="previousSchoolType">Previous School Type</label>
  <select
    name="previousSchoolType"
    id="previousSchoolType"
    value={formData.previousSchoolType}
    onChange={handleChange}
  >
    <option value="">Select Type</option>
    <option value="Government School">Government School</option>
    <option value="Private Aided School">Private Aided School</option>
    <option value="Local Bodies">Local Bodies</option>
    <option value="Private Unaided School">Private Unaided School</option>
  </select>
</div>

<div className="ans-form-group">
  <label htmlFor="previousSchoolPinCode">Pin Code</label>
  <input
    type="text"
    name="previousSchoolPinCode"
    id="previousSchoolPinCode"
    value={formData.previousSchoolPinCode}
    onChange={handleChange}
    pattern="\d{6}"
    maxLength="6"
    minLength="6"
    title="Enter a valid 6-digit pin code"
  />
</div>

<div className="ans-form-group">
  <label htmlFor="previousSchoolAddress">Previous School Address</label>
  <textarea
    name="previousSchoolAddress"
    id="previousSchoolAddress"
    value={formData.previousSchoolAddress}
    onChange={handleChange}
  />
</div>

        <div className="ans-form-group">
          <label htmlFor="paymentMode">Payment Mode</label>
          <select name="paymentMode" id="paymentMode" value={formData.paymentMode} onChange={handleChange} required>
            <option value="">Select Payment Mode</option>
            <option value="Cash">Cash</option>
            <option value="UPI">UPI</option>
          </select>
        </div>

        <div className="ans-form-group">
          <label htmlFor="transactionId">Transaction ID</label>
          <input type="text" name="transactionId" id="transactionId" value={formData.transactionId} onChange={handleChange} required />
        </div>

        <div style={{ display: 'flex', gap: '10px' }}>
  <button type="submit" className="ans-submit-button">Add Student</button>
  <button
  type="button"
  className="ans-submit-button"
  onClick={handlePrint}
  disabled={!submittedData}
  style={{ opacity: !submittedData ? 0.5 : 1 }}
>
  Print Application
</button>

</div>

      </form>
    </div>
  );
};

export default AddNewStudent;
